"use client";

import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { ChapterOverview } from "@/components/cockpit/ChapterOverview";
import { CockpitPageHeader } from "@/components/cockpit/CockpitPageHeader";

export const Route = createFileRoute("/_cockpit/cockpit/hundert-tage/kapitel/")({
  component: ChapterIndex,
});

/** Ticket Z7a: Kapitelübersicht als eigene, stabile Adresse. */
function ChapterIndex() {
  return (
    <div className="space-y-4">
      <Link
        to="/cockpit/hundert-tage"
        className="inline-flex items-center gap-1 text-sm font-semibold text-primary hover:underline"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden />
        Zurück zur Übersicht
      </Link>
      <CockpitPageHeader
        title="Kapitel zum Lesen"
        description="Alle Kapitel des Moduls auf einen Blick – von der Vorbereitung bis zum hundertsten Tag und Beiträge zu wiederkehrenden Fragen."
      />
      <ChapterOverview headingLevel="h2" />
    </div>
  );
}
